import { render, staticRenderFns } from "./PreviewCertificate.vue?vue&type=template&id=5c07dead"
import script from "./PreviewCertificate.vue?vue&type=script&lang=js"
export * from "./PreviewCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports